// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"df744e1d","350":"cef70d74","437":"599b730a","590":"d2b42ab0","607":"63940bd9","618":"16808d50","993":"270f8652"}[chunkId] + ".chunk.js";
};